// extracted by mini-css-extract-plugin
module.exports = {"colorsDropDown":"styles_colorsDropDown__8keoL"};